// import React, { useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { setLoginData, setLoading, setError } from '../../Redux/user_information';
// import { login_data } from '../../Services/Operations/ProductAPI';
// import '../../Styles/AdminLaout.css';

// const Login = ({ onLogin, onForgotPassword }) => {
//   const [formData, setFormData] = useState({
//     email: '',
//     password: ''
//   });
  
//   const dispatch = useDispatch();
//   const { isLoading, error } = useSelector((state) => state.user);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!formData.email || !formData.password) {
//       dispatch(setError('Please fill in all fields'));
//       return;
//     }

//     dispatch(setLoading(true));
//     dispatch(setError(null));

//     try {
//       const loginResponse = await login_data({
//         email: formData.email,
//         password: formData.password
//       });

//       if (loginResponse.success) {
//         dispatch(setLoginData(loginResponse));

//         if (onLogin) {
//           onLogin(loginResponse);
//         }
        
//         console.log('Login successful:', loginResponse);
//       } else {
//         dispatch(setError(loginResponse.message || 'Login failed'));
//       }
//     } catch (error) {
//       console.error('Login error:', error);
//       dispatch(setError('Login failed. Please check your credentials.'));
//     } finally {
//       dispatch(setLoading(false));
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });

//     if (error) {
//       dispatch(setError(null));
//     }
//   };

//   return (
//     <div className="login-page">
//       <div className="login-container">
//         <div className="login-header">
//           <h1>Admin Login</h1>
//           <p>Sign in to your account</p>
//         </div>
        
//         {error && (
//           <div className="error-message">
//             {error}
//           </div>
//         )}
        
//         <form className="login-form" onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label htmlFor="email">Email Address</label>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               placeholder="Enter your email"
//               required
//               disabled={isLoading}
//             />
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="password">Password</label>
//             <input
//               type="password"
//               id="password"
//               name="password"
//               value={formData.password}
//               onChange={handleChange}
//               placeholder="Enter your password"
//               required
//               disabled={isLoading}
//             />
//           </div>
          
//           <button 
//             type="submit" 
//             className="login-btn"
//             disabled={isLoading}
//           >
//             {isLoading ? 'Signing In...' : 'Sign In'}
//           </button>
          
//           <div className="login-footer">
//             <button 
//               type="button" 
//               className="forgot-password-btn"
//               onClick={onForgotPassword}
//               disabled={isLoading}
//             >
//               Forgot Password?
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginData, setLoading, setError } from '../../Redux/user_information';
import { login_data } from '../../Services/Operations/ProductAPI';
import '../../Styles/AdminLaout.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Login = ({ onLogin, onForgotPassword }) => {
    const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  
  const dispatch = useDispatch();
  const { isLoading, error } = useSelector((state) => state.user);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email || !formData.password) {
      dispatch(setError('Please fill in all fields'));
      return;
    }

    dispatch(setLoading(true));
    dispatch(setError(null));

    try {
      const loginResponse = await login_data({
        email: formData.email,
        password: formData.password
      });

      if (loginResponse.success) {
        dispatch(setLoginData(loginResponse));

        if (onLogin) {
          onLogin(loginResponse);
        }
        
        console.log('Login successful:', loginResponse);
        navigate("/")
      } else {
        dispatch(setError(loginResponse.message || 'Login failed'));
      }
    } catch (error) {
      console.error('Login error:', error);
      dispatch(setError('Login failed. Please check your credentials.'));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

    if (error) {
      dispatch(setError(null));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>Admin Login</h1>
          <p>Sign in to your account</p>
        </div>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
              disabled={isLoading}
            />
          </div>
          
          <div className="form-group password-group">
            <label htmlFor="password">Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
                disabled={isLoading}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={togglePasswordVisibility}
                disabled={isLoading}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          
          <button 
            type="submit" 
            className="login-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Signing In...' : 'Sign In'}
          </button>
          
          <div className="login-footer">
            <button 
              type="button" 
              className="forgot-password-btn"
              onClick={onForgotPassword}
              disabled={isLoading}
            >
              Forgot Password?
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;